<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
          <div>
            <p class="weight">Mingliang Fang, PhD</p>
            <p>
              <span class="weight">Titile/Position:</span> Professor
            </p>
          </div>
          <div>
            <div class="weight">Affiliation:</div>
            <div>Fudan University</div>
          </div>
        <div>
            <span class="weight">Email: </span>
            <span class="blue">mlfang@fudan.edu.cn</span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
        <div  class="weight">Brief introduction:</div>
        <div class="content">
          Dr. Fang is currently a full professor at Fudan University in China. He received his Ph.D. degree in Environmental Chemistry and Toxicology and postdoctoral training in metabolomics. From 2016 to 2022, he worked as an Assistant Professor at Nanyang Technological University (Singapore). The main focus of his research is on the development of exposome methods, and the use of systems biology methods to study chemical toxicity and protein targets. Dr. Fang has published ～100 peer-reviewed papers on the journals including Nature Chemical Biology, PNAS, Environmental Health Perspective, Analytical Chemistry, and Environmental Science & Technology. He also works as the Editor of the journal “Environmental Pollution” and serves as Editorial Board member in multiple high-tier journals of Environmental Science: Processes & Impacts (RSC), Environment International (Elsevier), Environmental Research (Elsevier), Chemosphere (Elsevier), ES&T Water （ACS）and Exposome (Oxford).
        </div>
      </div>
    <div class="section">
        <div class="weight">Representative papers:</div>
        <p>
          1. Mengjing Wang, Qianqian Li, Meifang Hou, Louisa LY Chan, Meng Liu, Soo Kai Terd, Ting Dong, Yun Xia*, Sanjay H Chotirmalld, <span  class="weight">Mingliang Fang</span>*. Inactivation of common airborne antigens by perfluoroalkyl chemicals modulates early-life allergic asthma. Proceedings of the National Academy of Sciences of the United States of America. 2021
        </p>
        <p>
          2. Beyer, B. A.#, <span  class="weight">Fang, M</span>.# （Equal Contribution）, Sadrian, B., Montenegro-Burke, J. R., Plaisted, W. C., Kok, B. P., ... & Lairson, L. L*. (2018). Metabolomics-based discovery of a metabolite that enhances oligodendrocyte maturation. Nature Chemical Biology,  14(1), 22-28. https://doi.org/10.1038/nchembio.2517
        </p>
        <p>
          3. <span  class="weight">M Fang</span>, L Hu, D Chen, Y Guo, J Liu, C Lan, J Gong, B Wang. “Exposome” in Human Health: Utopia or Wonderland? The Innovation, 100172, 2021
        </p>
        <p>
          4. Fanrong Zhao, Li Li, Yue Chen, Yichao Huang, Tharushi Prabha Keerthisinghe, Agnes Chow, Ting Dong, Shenglan Jia, Shipei Xing, Benedikt Warth, Tao Huan and <span  class="weight">Mingliang Fang</span>*. Risk-based Chemical Ranking and Generating a Prioritized Human Exposome Database. Environmental Health Perspective. 2021.
        </p>
        <p>
          5. Liu, M., Jia, S., Dong, T., Zhao, F., Xu, T., Yang, Q., ... & <span  class="weight">Fang, M</span>*. (2020). Metabolomic and Transcriptomic Analysis of MCF-7 Cells Exposed to 23 Chemicals at Human-Relevant Levels: Estimation of Individual Chemical Contribution to Effects. Environmental Health Perspectives  https://doi.org/10.1289/EHP6641
        </p>
        <p>
          6. <span  class="weight">Fang, M</span>., Webster, T. F., Ferguson, P. L., & Stapleton, H. M*. (2015). Characterizing the peroxisome proliferator-activated receptor (PPARγ) ligand binding potential of several major flame retardants, their metabolites, and chemical mixtures in house dust. Environmental Health Perspectives,  123(2), 166-172. https://doi.org/10.1289/ehp.1408522
        </p>
        <p>
          7. Hoffman, K.#, <span  class="weight">Fang, M</span>.# （Equal Contribution）, Horman, B., Patisaul, H. B., Garantziotis, S., Birnbaum, L. S., & Stapleton, H. M. *(2014). Urinary tetrabromobenzoic acid (TBBA) as a biomarker of exposure to the flame retardant mixture Firemaster® 550. Environmental Health Perspectives,  122(9), 963-969. https://doi.org/10.1289/ehp.1308028
        </p>
        <p>
          8. Liu, Min; Jiang, Jie; Jie, Zheng; Huan, Tao; Gao, Bei ; Fei, Xunchang; Wang, Yulan; <span  class="weight">Fang, Mingliang</span>*. RTP: One Effective Platform to Probe Reactive Compound Transformation Products and Its Applications for a Reactive Plasticizer BADGE. Environmental Science & Technology. 2021.
        </p>
        <p>
          9. Xu, Tengfei; Chen, Liyan; Lim, Yan Ting; Zhao, Haoduo; Chen, Hongjin; Chen, Mingwei; Huan, Tao; Huang, Yichao; Sobota, Radoslaw ; <span  class="weight">Fang, Mingliang</span>*. (2021). Systems Biology-Guided Chemical Proteomics to Discover Protein Targets of Monoethylhexyl Phthalate in Regulating Cell Cycle. Environmental Science & Technology. 2021, 55, 3, 1842–1851.
        </p>
        <p>
          10. Xu, T., Lim, Y. T., Chen, L., Zhao, H., Low, J. H., Xia, Y., ... & <span  class="weight">Fang, M</span>*. (2020). A Novel Mechanism of Monoethylhexyl Phthalate in Lipid Accumulation via Inhibiting Fatty Acid Beta-Oxidation on Hepatic Cells. Environmental Science & Technology. https://doi.org/10.1021/acs.est.0c01073
        </p>
        <p>
          11. Huang, Y., & <span  class="weight">Fang, M</span>*. (2020). Nutritional and Environmental Contaminant Exposure: A Tale of Two Co-Existing Factors for Disease Risks. Environmental Science & Technology. https://doi.org/10.1021/acs.est.0c05658
        </p>
        <p>
          12. Dong, T.#, Zhang, Y.#, Jia, S., Shang, H., Fang, W., Chen, D., & <span  class="weight">Fang, M</span>*. (2019). Human indoor exposome of chemicals in dust and risk prioritization using EPA’s ToxCast database. Environmental Science & Technology,  53(12), 7045-7054. https://doi.org/10.1021/acs.est.9b00280
        </p>
        <p>
          13. Jia, S., Xu, T., Huan, T., Chong, M., Liu, M., Fang, W., & <span  class="weight">Fang, M</span>*. (2019). Chemical isotope labeling exposome (CIL-EXPOSOME): one high-throughput platform for human urinary global exposome characterization. Environmental Science & Technology,  53(9), 5445-5453. https://doi.org/10.1021/acs.est.9b00285
        </p>
        <div>Note：* Corresponding author, # Co-first author</div>
      </div>
  </div>
</template>
<script>
import img from '@/assets/people/head2.png';
export default {
  data() {
    return {
      img,
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>
